import { FC, useState } from "react";

interface FaqItemProps {
  className?: string;
  texts: {
    title: string;
    questions: { question: string; answer: string }[];
    icon: string;
  }[];
}

const FaqItem: FC<FaqItemProps> = ({ texts }) => {
  const [openQuestions, setOpenQuestions] = useState<number[]>([]);

  const handleToggleQuestion = (index: number) => {
    setOpenQuestions((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  return (
    <div>
      {texts.map((section, sectionIndex) => (
        <div key={sectionIndex} className="listingSection__wrap mb-8">
          {/* HEADING */}
          <h2 className="text-2xl font-semibold">{section.title}</h2>
          <div className="w-14 border-b border-neutral-200 dark:border-neutral-700 mb-4"></div>

          {/* QUESTIONS */}
          <div className="divide-y divide-neutral-100 dark:divide-neutral-800">
            {section.questions.map((question, questionIndex) => (
              <div
                key={questionIndex}
                className="nc-FaqItem"
                data-nc-id="FaqItem"
              >
                <div
                  className="flex justify-between items-center cursor-pointer py-4"
                  onClick={() =>
                    handleToggleQuestion(sectionIndex * 1000 + questionIndex)
                  }
                >
                  <div className="flex items-center">
                    {/* <i className={`la la-${section.icon} text-4xl mr-3`}></i> */}
                    <span className="text-lg font-medium">
                      {question.question}
                    </span>
                  </div>
                  <i
                    className={`la ${
                      openQuestions.includes(
                        sectionIndex * 1000 + questionIndex
                      )
                        ? "la-angle-up"
                        : "la-angle-down"
                    } text-2xl`}
                  ></i>
                </div>
                {openQuestions.includes(
                  sectionIndex * 1000 + questionIndex
                ) && (
                  <div className="mt-3 mb-6 text-neutral-6000 dark:text-neutral-300">
                    <span
                      className="block"
                      dangerouslySetInnerHTML={{ __html: question.answer }}
                    ></span>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default FaqItem;
